import isEmpty from "lodash/isEmpty";
import toNumber from "lodash/toNumber";
import isEqual from "./isEqual";

import CryptoJS from "crypto-js";

import * as format from "./format";
import * as gcUtil from "./getComponent";
import * as caUtil from "./callApi";
import watermark from "./watermark";
import { WaterMarkCanvas, Canvas2Image } from "./html2image";
import Base64WithLocale from "./base64";
import * as dUtil from "./dialog";
import messageCenter from "./messageCenter";
import WindowFunc from "./window";
import { sendMsgToPC } from "../wea-popover-hrm/util";
import { ls, ss } from "./storage";
import loadjs from "loadjs";
import * as UnloadHook from "./onbeforeunload";
import { openRewrite } from "./open";
import { UserAgent, ua } from "./userAgent";
import * as EncryBase from "./Encry.base";

import "./index.less";
require("./eventRegister.js");
require("./jquery.poshytip.js");
require("./hrmBrowserUtil.js");
import { message } from "antd";

import WeaLocaleProvider from "../wea-locale-provider";
import { loadCss } from "./loadCss";
import { viewer } from "./viewer";
import { loadDevModules } from "./loadDevModules";
import checkStdRouter from "./checkRouter";
import getReverseColor from "./color";
import getFrameParams from "./getUrlParams";
import { checkSSO, checkCustomSSO, ssoLogout } from "./checkSSO";
import { checkLang } from "./baseLanguageInterval";
import { checkJoin, getEmAudioOrVideo, checkDing, createDing } from "./emTools";
import initContentPath from "./contentPath";
import initTimeoutSwitch from "./timeoutSwitch";
import getOs from "./getOsInfo";

const getLabel = WeaLocaleProvider.getLabel;

let utf8 = require("utf8");
// let Base64WithLocale = {...Base64, decode: function(str) {
//   let base64Str = Base64.decode(str);
//   return WeaLocaleProvider.formatMultiLang(base64Str);
// }};

const getSelectDefaultValue = gcUtil.getSelectDefaultValue;

// fetch 部分处理
const server = window.server || "";

const trim = s => {
  return s.replace(/(^\s*)|(\s*$)/g, "");
};

const tools = {
  getOsInfo: getOs,
  openRewrite,
  watermark,
  EncryBase,
  WaterMarkCanvas,
  Canvas2Image,
  UserAgent,
  ua,
  messageCenter,
  WindowFunc,
  ls,
  ss,
  tryCatch(React, ErrorHandler, handlerOptions) {
    if (!React || !React.Component) {
      throw new Error(
        "arguments[0] for react-try-catch-render does not look like React."
      );
    }
    if (typeof ErrorHandler !== "function") {
      throw new Error(
        "arguments[1] for react-try-catch-render does not look like a function."
      );
    }
    /**
     * Implementation of the try/catch wrapper
     * @param  {[React.Component]} component The ES6 React.Component
     */
    return function wrapWithTryCatch(Component) {
      const originalRender = Component.prototype.render;

      Component.prototype.render = function tryRender() {
        try {
          return originalRender.apply(this, arguments);
        } catch (err) {
          // Log an error
          window.console && console.error("errorLog:", err);
          if (ErrorHandler.prototype && ErrorHandler.prototype.render) {
            return React.createElement(ErrorHandler, handlerOptions);
          }
          // ErrorHandler is at least a valid function
          return ErrorHandler(err);
        }
      };
      return Component;
    };
  },
  downloadFile: (url, method, params) => {
    if (!params) params = {};
    if (
      typeof localStorage.access_token === "string" &&
      localStorage.access_token !== ""
    ) {
      params.access_token = localStorage.access_token;
    }
    var reg = new RegExp("^" + window.ecologyContentPath + "");
    url = reg.test(url) ? url : (window.ecologyContentPath || "") + url;
    url = `${server}${url}`;
    let form = jQuery("<form></form>")
      .attr("action", url)
      .attr("method", method);
    let inputs = "";
    for (let key in params) {
      inputs +=
        '<input type="hidden" name="' +
        key +
        '" value="' +
        params[key] +
        '" />';
    }
    inputs += '<input type="hidden" name="testHolder" value="testHolder" />';
    form.append(inputs);
    form
      .appendTo("body")
      .submit()
      .remove();
  },
  checkSession: (nextState, replace, callback) => {
    callback();
  },
  isComponentHide(field) {
    let hide = false;
    if (field) {
      let ct = field.conditionType.toUpperCase();
      let viewAttr = field.viewAttr;
      if (ct == "BROWSER") viewAttr = field.browserConditionParam.viewAttr;
      hide = viewAttr == -1; // -1 隐藏
    }
    return hide;
  },

  math() {
    return new Promise((resolve, reject) => {
      if (window.math) {
        resolve(window.math);
      } else {
        this.loadJs(
          "mathjs",
          (window.ecologyContentPath || "") +
            "/cloudstore/resource/pc/mathjs/math.min.js",
          () => {
            resolve(window.math);
          }
        );
      }
    });
  },
  loadJs(sid, jsurl, callback) {
    var nodeHead = document.getElementsByTagName("head")[0];
    var nodeScript = null;
    if (document.getElementById(sid) === null) {
      nodeScript = document.createElement("script");
      nodeScript.setAttribute("type", "text/javascript");
      nodeScript.setAttribute("src", jsurl);
      nodeScript.setAttribute("id", sid);
      if (callback != null) {
        nodeScript.onload = nodeScript.onreadystatechange = function() {
          if (nodeScript.ready) {
            return false;
          }
          if (
            !nodeScript.readyState ||
            nodeScript.readyState === "loaded" ||
            nodeScript.readyState === "complete"
          ) {
            nodeScript.ready = true;
            callback();
          }
        };
      }
      nodeHead.appendChild(nodeScript);
    } else {
      if (callback != null) {
        callback();
      }
    }
  },
  loadjs: loadjs,
  getSelectDefaultValue,
  formatRealDate: format.formatDate,
  formatDate: format.formatToDate,
  formatTime: format.formatToTime,
  getParamsByConditions: gcUtil.getParamsByConditions,
  getComponent: gcUtil.getComponent,
  getFd: caUtil.getFd,
  callApi: caUtil.callApi,
  Base64: Base64WithLocale,
  loadCss: loadCss,
  viewer: viewer,
  loadDevModules: loadDevModules,
  checkStdRouter,
  getReverseColor,
  getUrlParams: getFrameParams,
  checkSSO: checkSSO,
  checkJoin: checkJoin,
  getEmAudioOrVideo,
  checkDing,
  createDing,
  checkLang: checkLang,
  checkCustomSSO: checkCustomSSO,
  ssoLogout: ssoLogout,
  isEqual,
  utf8,
  CryptoJS,
  getDialog: dUtil.getDialog,
  createDialog: dUtil.createDialog,
  createReactEle: dUtil.createReactEle,
  getIconBGC: dUtil.getIconBGC,
  UnloadHook: UnloadHook,
  getTextWidth(str) {
    let width = 0;
    if (str) {
      for (var i = 0; i < str.length; i++) {
        // 如果是汉字
        if (str.charCodeAt(i) > 255) {
          width += 14;
        } else {
          width += 7;
        }
      }
    }
    return width;
  },
  getZindex(page = "home", defaultIndex = 99) {
    const key = `${page}ZINDEX`;
    const cache = this.ss.getStr(key);
    const zindex = cache ? Number(cache) + 1 : defaultIndex;
    this.ss.set(key, zindex);
    return zindex;
  },
  tooltip(dom, params = {}) {
    // http://vadikom.com/demos/poshytip/
    if (!dom || !jQuery) return;
    if (!(dom instanceof jQuery)) {
      dom = jQuery(dom);
    }
    if (typeof params === "string") return dom.poshytip(params);
    const config = {
      ...{
        className: "tip-yellow",
        alignX: "right",
        alignY: "center",
        fade: false,
        slide: false,
        offsetX: 0
      },
      ...params
    };
    dom.poshytip(config);
  },
  isWeekendDay(str) {
    let bool = false;
    if (str) {
      let dt = new Date(str);
      if (dt.getDay() == 0 || dt.getDay() == 6) {
        bool = true;
      }
    }
    return bool;
  },
  isBelowIE9() {
    return (
      navigator.appName == "Microsoft Internet Explorer" &&
      parseInt(
        navigator.appVersion
          .split(";")[1]
          .replace(/[ ]/g, "")
          .replace("MSIE", "")
      ) <= 9
    );
  },
  /**
   * INPUT ： 文本输入框
   * SELECT ： 下拉选择框
   * DATE ： 日期格式
   * DATEPICKER ：日期格式 不带区间
   * TIMEPICKER ：时间选择
   * YEARPICKER ：年份选择
   * MONTHPICKER ：年月选择
   * BROWSER ：浏览框
   * SELECT_LINKAGE ：下拉选择框联动
   * INPUT_INTERVAL   ：input 区间
   * SCOPE ： input 区间
   * CHECKBOX：check框
   * SWITCH：switch开关
   * TIMEPICKER ：时间
   * TIME_INTERVAL ：时间区间
   * CUSTOM ： 自定义组件(流程自定义查询相关)
   * CASCADER： 多级级联组件
   * INPUTNUMBER： 整数小数输入框
   * PERIOD： 时间段选择
   * UPLOAD： 上传
   * RICHTEXT： 富文本
   * TAGGROUP： 标签组
   * DESCRIPTION：说明
   */
  types: {
    INPUT: "INPUT",
    PASSWORD: "PASSWORD",
    BROWSER: "BROWSER",
    CHECKBOX: "CHECKBOX",
    DATEPICKER: "DATEPICKER",
    TIMEPICKER: "TIMEPICKER",
    YEARPICKER: "YEARPICKER",
    MONTHPICKER: "MONTHPICKER",
    SELECT: "SELECT",
    TEXTAREA: "TEXTAREA",
    DATE: "DATE",
    SCOPE: "SCOPE",
    SELECT_LINKAGE: "SELECT_LINKAGE",
    SWITCH: "SWITCH",
    RANGEPICKER: "RANGEPICKER",
    TIMERANGEPICKER: "TIMERANGEPICKER",
    COLORPICKER: "COLORPICKER",
    CASCADER: "CASCADER",
    CASCADERCUSTOMFIELD: "CASCADERCUSTOMFIELD", // CASCADER的子组建
    INPUTNUMBER: "INPUTNUMBER",
    INPUTSEARCH: "INPUTSEARCH",
    PERIOD: "PERIOD",
    UPLOAD: "UPLOAD",
    RICHTEXT: "RICHTEXT",
    TAGGROUP: "TAGGROUP",
    DESCRIPTION: "DESCRIPTION"
  },
  getKey(f) {
    let key = "";
    if (f.domkey) key = f.domkey.join("__");
    return key;
  },
  getValueByfield(field) {
    if (!field) return {};
    const type = field.conditionType.toUpperCase();
    const types = this.types;
    let arrs = [
      types.RICHTEXT,
      types.INPUT,
      types.PASSWORD,
      types.CHECKBOX,
      types.DATEPICKER,
      types.TIMEPICKER,
      types.TEXTAREA,
      types.SWITCH,
      types.COLORPICKER,
      types.INPUTNUMBER,
      types.DESCRIPTION
    ];
    if (arrs.indexOf(type) > -1) {
      if (field.value !== undefined) {
        return {
          value: field.value
        };
      }
    }
    if ([types.CASCADERCUSTOMFIELD, types.CASCADER].indexOf(type) > -1) {
      if (field.value !== undefined || field.values !== undefined) {
        return {
          value: field.values || field.value
        };
      }
    }
    if (types.SELECT === type) {
      let value = this.getSelectDefaultValue(
        { ...field.options },
        field.detailtype
      );
      if (field.value != undefined && field.value !== "") value = field.value;
      let valueSpan = "";
      let target =
        field.options && field.options.filter(data => data.key == value)[0];
      valueSpan = target ? target.showname : "";
      if (value !== undefined) {
        return {
          value,
          valueSpan
        };
      }
    }
    if (types.BROWSER === type) {
      if (!isEmpty(field.browserConditionParam)) {
        const replacesDatas =
          field.browserConditionParam.replaceDatas ||
          field.browserConditionParam.valueObj;
        if (!isEmpty(replacesDatas)) {
          let values = [],
            names = [];
          replacesDatas.forEach(d => {
            if (d) {
              values.push(d.id);
              names.push(d.lastname || d.name); // 人力按钮特殊处理
            }
          });
          return {
            value: values.join(","),
            valueSpan: names.join(","),
            valueObj: replacesDatas
          };
        }
      }
    }
    if (types.DATE === type) {
      let selectValue = "0",
        startValue = null,
        endValue = null;
      if (!isEmpty(field.options))
        selectValue = this.getSelectDefaultValue(field.options) || selectValue;
      if (!isEmpty(field.value)) {
        selectValue = field.value[field.domkey[0]];
        startValue = field.value[field.domkey[1]];
        endValue = field.value[field.domkey[2]];
      }
      return {
        value: [selectValue, startValue, endValue]
      };
    }

    if (types.SELECT_LINKAGE === type) {
      let selectValue =
        this.getSelectDefaultValue(field.options) ||
        (field.options[0] ? field.options[0].key : "");
      let resp = [selectValue];
      if (field.selectLinkageDatas) {
        let rightField = field.selectLinkageDatas[selectValue];
        if (rightField) {
          let rightValues = this.getValueByfield(rightField);
          if (rightValues) {
            let rightResult = [];
            let rightType = rightField.conditionType.toUpperCase();
            if (types.BROWSER === rightType) {
              rightResult[0] = rightValues.value;
              rightResult[1] = rightValues.valueSpan;
              rightResult[2] = rightValues.valueObj;
            } else if (
              [
                types.RANGEPICKER,
                types.TIMERANGEPICKER,
                types.SCOPE,
                types.DATE
              ].indexOf(rightType) > -1
            ) {
              rightResult = rightValues.value;
            } else {
              rightResult[0] = rightValues.value;
            }
            resp[1] = rightResult;
          }
        }
      }
      return {
        value: resp
      };
    }

    if (types.SCOPE === type) {
      let sValue = field.startValue || "",
        eValue = field.endValue || "";
      if (sValue) sValue = toNumber(sValue);
      if (eValue) eValue = toNumber(eValue);
      return {
        value: [sValue, eValue]
      };
    }

    if ([types.RANGEPICKER, types.TIMERANGEPICKER].indexOf(type) > -1) {
      let sValue =
          field.startDate || field.startValue || field[field.domkey[0]] || "",
        eValue =
          field.endDate || field.endValue || field[field.domkey[1]] || "";
      let result = [sValue, eValue];
      if (!sValue && !eValue) result = [];
      return {
        value: result
      };
    }

    if (types.PERIOD === type) {
      return {
        value: field.value
      };
    }

    if (types.UPLOAD === type) {
      if (field.datas && !isEmpty(field.datas)) {
        const value = field.datas.map(t => t.fileid || t.id).join(",");
        return {
          value,
          valueSpan: field.datas
        };
      }
    }

    if (types.TAGGROUP === type) {
      if (field.datas && !isEmpty(field.datas)) {
        const value = field.datas.map(t => t.id).join(",");
        return {
          value,
          valueSpan: field.datas
        };
      }
    }

    // add custom field default value
    if (field.value !== undefined) {
      return {
        value: field.value
      };
    }
  },
  getStringLength(val = "") {
    let len = 0;
    for (let i = 0; i < val.length; i++) {
      let c = val.charCodeAt(i);
      //单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++;
      } else {
        len += 3;
      }
    }
    return len;
  },
  getStringByLength(val = "", length) {
    let len = 0,
      str = "";
    for (let i = 0; i < val.length; i++) {
      let c = val.charCodeAt(i);
      let s = val.charAt(i);
      //单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++;
      } else {
        len += 3;
      }
      if (len > length) return str;
      str += s;
    }
  },
  transHTML(val = "") {
    let result = val
      .replace(/>/g, "&gt;")
      .replace(/</g, "&lt;")
      // .replace(/&gt;/g, ">")
      // .replace(/&lt;/g, "<")
      .replace(/\n/g, "<br/>")
      .replace(/\r/g, "<br/>")
      .replace(/\s/g, "&nbsp;")
      .replace(/'/g, "&apos;")
      .replace(/"/g, "&quot;");
    return result;
  },
  downloadCvs2Img(cvs, picName = "Download") {
    if (this.isBelowIE9()) {
      message.warning(
        getLabel(
          385817,
          "IE9以下版本浏览器不支持下载功能，请换个其他版本的浏览使用"
        )
      );
      return;
    }
    if (!cvs) {
      return;
    }
    let $a = document.createElement("a");
    $a.download = `${picName}.jpg`;
    $a.target = "_blank";
    const url = cvs.toDataURL("image/jpg");
    $a.href = url;
    if (typeof MouseEvent === "function") {
      var evt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false
      });
      $a.dispatchEvent(evt);
    } else {
      if (window.navigator.msSaveOrOpenBlob) {
        var bstr = atob(url.split(",")[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, "Download.jpg");
      } else {
        // var lang = model.get('lang');
        var html =
          "" +
          '<body style="margin:0;">' +
          '<img src="' +
          url +
          '" style="max-width:100%;" title="" />' +
          "</body>";
        var tab = window.open();
        tab.document.write(html);
      }
    }
  },
  /** 发送消息*/
  sendMsg: sendMsgToPC
};

const openFullWindowHaveBar = url => {
  var redirectUrl = url;
  var width = screen.availWidth - 10;
  var height = screen.availHeight - 50;
  var szFeatures = "top=0,";
  szFeatures += "left=0,";
  szFeatures += "width=" + width + ",";
  szFeatures += "height=" + height + ",";
  szFeatures += "directories=no,";
  szFeatures += "status=yes,toolbar=no,location=no,";
  szFeatures += "menubar=no,";
  szFeatures += "scrollbars=yes,";
  szFeatures += "resizable=yes";
  window.open(redirectUrl, "", szFeatures);
};

window.openFullWindowHaveBar = openFullWindowHaveBar;
window.openFullWindowForXtable = openFullWindowHaveBar;
initContentPath();
initTimeoutSwitch();
// initBaseLanguageInterval();
// initRefreshLanguageInterval();
export default tools;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/index.js